export const Arrow = (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 72.8 201.68"
  >
    <polygon
      className="st0"
      points="72.13,11.79 49.59,0.67 0.56,100.81 49.59,200.95 70.76,187.43 29.94,100.81 "
    />
  </svg>
);

export const rangeMapper = (value, x1, y1, x2, y2) =>
  ((value - x1) * (y2 - x2)) / (y1 - x1) + x2;

export const clamp = (val, min, max) => {
  return val > max ? max : val < min ? min : val;
};
